import { render, staticRenderFns } from "./SpecialistStatisticsIndividual.vue?vue&type=template&id=42e10774&scoped=true&"
import script from "./SpecialistStatisticsIndividual.vue?vue&type=script&lang=js&"
export * from "./SpecialistStatisticsIndividual.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistStatisticsIndividual.vue?vue&type=style&index=0&id=42e10774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e10774",
  null
  
)

export default component.exports